import { chakra } from '@chakra-ui/react';

export const Span = chakra('span');
